import type { ReportItem } from "@/lib/report-catalog"

export type ReportVisibilityMap = Record<string, boolean>

export function isReportVisible(api: string, visibility?: ReportVisibilityMap | null): boolean {
  if (!visibility) return true
  return visibility[api] !== false
}

export function filterVisibleReports(
  reports: ReportItem[],
  visibility?: ReportVisibilityMap | null,
): ReportItem[] {
  return reports.filter((report) => isReportVisible(report.api, visibility))
}
